import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history", //hash | abstract | history
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/portfolio"
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./views/About.vue")
    },
    {
      path: "/callback",
      name: "callback",
      component: () => import("./views/Callback.vue")
    },
    {
      path: "/signout",
      name: "signout",
      component: () => import("./views/SignOut.vue")
    },
    {
      path: "/portfolio",
      name: "portfolio",
      component: () => import("./views/Portfolio.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import("./views/PrivacyAlexa.vue")
    },
    {
      path: "/privacy-au",
      name: "privacy-au",
      component: () => import("./views/PrivacyAU.vue")
    },
    { path: "*", component: () => import("./views/404.vue") }
  ]
});
